/* A tenant user's role (docs/API.md → Enums, TenantRole; Permissions). */
export enum TenantRole {
    Admin  = 'admin',
    Editor = 'editor',
}

export const TENANT_ROLES: TenantRole[] = [TenantRole.Admin, TenantRole.Editor]
